<template lang="pug">
  .input(:class="classes")
    //- input.input__control(v-model="inputValue", :placeholder="input.placeholder", ref="input", v-validate="input.validateRules", :name="input.name", :disabled="disabled" type="text", @focus="handleFocus", @blur="handleBlur", @input="handleInput")
    Vue-suggestions(:model.sync="inputValue", :validate="input.validateRules", :name="index ? input.name + index : input.name", :placeholder="input.placeholder", class="input__control", :options="options",@focus="handleFocus", @blur="handleBlur")
    .input__error
      |{{index ? errors.first(input.name + index) : errors.first(input.name)}}
    //- .input__desc(v-if="input.hasDescription")
    //-   |Например
    //-   a.input__desc-link(href="#", @click.prevent)
    //-     |{{descLink}}
    //- .input__error(v-if="isError")
      |{{errors.first(input.name)}}

</template>

<script>
  import Inputmask from 'inputmask';
  import VueSuggestions from '@/components/vue-suggestions';
export default {

  inject: ['$validator'],
  props:{
    index:null,
    input: null,
    model: null,
    options:null,
    disabled: {
      default:false,
      required:false
    }
  },
  name: 'app-input',
  components: {
    VueSuggestions
  },
  data() {
    return {
      isFocus: false
    }
  },
  mounted() {
    if (this.input.mask) {
        this.setMask();
    }
    
  },
  methods:{
    setMask() {
      const placeholder =
        this.input.maskPlaceholder != 'undefined'
            ? this.input.maskPlaceholder
            : '_';

      if (this.input.maskRegex) {
        new Inputmask({
            showMaskOnHover: false,
            placeholder,
            regex: this.input.mask
        }).mask(this.$refs.input);
      } else {
        new Inputmask(this.input.mask, {
            showMaskOnHover: false,
            placeholder
        }).mask(this.$refs.input);
      }
    },
    handleFocus(){
      this.$emit('handleFocus');
      this.isFocus = true;
    },
    handleBlur(){
      if(this.isEmpty) {
        this.isFocus = false;
      }
      this.$emit('handleBlur');
    },
    
  },
  computed:{
    inputValue: {
      get() {
          return this.model;
      },
      set(field) {
          this.$emit('update:model', field);
          this.$emit('handleInput');
      }
    },
    isError() {
      if(this.index) {
        return this.errors.has(this.input.name + this.index);
      }
      return this.errors.has(this.input.name);
    },
    isEmpty() {
      if (this.inputValue) {
          return false;
      } else {
          return true;
      }
    },
    classes() {
      return {
        'is_status-focus': this.isFocus || !this.isEmpty,
        'is_status-error': this.isError,
        'is_status-valid': !this.isEmpty && !this.isError,
        'is_status-disabled': this.isDisabled
      };
    }
    // ...mapGetters({
    //   sportList: 'getSportList',
    //   sportTariffs: 'getSportTariffs',
    // })
  }
}
</script>

<style lang="scss">
  

</style>
